import React from 'react';
import ReactExport from 'react-data-export';
import {Button} from '@material-ui/core';
import Icon from '@mdi/react';
import {mdiProgressDownload, mdiTableArrowUp} from '@mdi/js';

const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;

interface Props {
  loading: boolean;
  data: [];
  handleRequest: any;
  filtersValues: any;
}

const ExelExport = ({loading, data, handleRequest, filtersValues}: Props) => {
  const handleCreateExel = () => {
    handleRequest({...filtersValues, page: undefined, size: 2000});
  };

  if (data?.length > 0) {
    return (
      <ExcelFile
        element={
          <Button
            style={{
              marginLeft: '5px',
              fontSize: '0.9375rem',
              padding: '8px 22px',
            }}
            variant="contained"
            color="primary"
            startIcon={<Icon path={mdiProgressDownload} size={1} />}
          >
            دانلود فایل EXCEL
          </Button>
        }
      >
        <ExcelSheet data={data} name="packages">
          {data &&
            Object.entries(data[0])?.map(el => {
              return <ExcelColumn label={el[0]} value={el[0]} />;
            })}
        </ExcelSheet>
      </ExcelFile>
    );
  } else {
    return (
      <Button
        style={{marginLeft: '5px'}}
        variant="contained"
        color="primary"
        startIcon={<Icon path={mdiTableArrowUp} size={1} />}
        onClick={handleCreateExel}
        disabled={loading}
      >
        ایجاد فایل EXCEL
      </Button>
    );
  }
};

export default ExelExport;
